import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';

const HowToPlay = () => {
	const { t } = useTranslation();

	return (
		<div id="HowToPlay1" className="page1">
			<div className="wrapperMedium">
				<PageTitle>
					<h1>{t('How To Play')}</h1>
				</PageTitle>

				{/* <div>
					<img className="width-100" src="assets/HowToPlay/HowToPlay.png" />
				</div> */}

				<h2>{t('Objective')}:</h2>
				<p>{t('The main goal of Hearts is to have the lowest score by the end of the game.')} {t('The game typically continues until a predetermined score is reached, often 50 points.')}</p>

				<h2>{t('Setup')}:</h2>
				<ul>
					<li>{t('Use a standard 52-card deck.')}</li>
					<li>{t('Deal 13 cards to each player.')}</li>
				</ul>

				<h2>{t('Gameplay')}:</h2>
				<ol>
					<li><strong>{t('Passing Cards')}:</strong>
						<ul>
							<li>{t('Before each hand, players select and pass three cards to a neighbor (varies each round: left, right, across, or no passing).')}</li>
							<li>{t('The player holding the 2 of clubs leads the first trick.')}</li>
						</ul>
					</li>
					<li><strong>{t('Trick-Taking')}:</strong>
						<ul>
							<li>{t('Players must follow suit if possible; otherwise, they can play any card.')}</li>
							<li>{t('The player with the highest card of the lead suit wins the trick and leads the next one.')}</li>
							<li>{t('Hearts cannot be led until they have been "broken" in a previous trick.')}</li>
						</ul>
					</li>
					<li><strong>{t('Scoring')}:</strong>
						<ul>
							<li>{t('Each heart card taken in a trick is worth one penalty point.')}</li>
							<li>{t('The Queen of Spades is worth 13 penalty points.')}</li>
							<li>{t('Players aim to avoid taking hearts and the Queen of Spades.')}</li>
						</ul>
					</li>
					<li><strong>{t('End of Hand')}:</strong>
						<ul>
							<li>{t('The hand continues until all 13 tricks are played.')}</li>
							<li>{t('Scores are tallied, and the next hand begins with passing cards again.')}</li>
						</ul>
					</li>
				</ol>

				<h2>{t('Winning')}:</h2>
				<p>{t('The game continues until a player reaches the predetermined score.')} {t('The player with the lowest score at the end of the game is the winner.')}</p>

				<h2>{t('Strategies')}:</h2>
				<p>{t('Players often try to "shoot the moon" by taking all the hearts and the Queen of Spades in a single hand.')} {t('If successful, they score no penalty points, and each opponent receives 26 penalty points.')}</p>
				<div style={{
					margin: '20px 0px',
				}}>-</div>
			</div>

		</div>
	);
};

export default React.memo(HowToPlay);
